import FirmaConservadorClass from "src/app/model/api/datos/firmaConservadorClass";
import DatabaseTable from "src/app/model/database/generic/databaseTable";

export default class FirmasConservadorTable extends DatabaseTable<FirmaConservadorClass> {

    public async getAll(): Promise<FirmaConservadorClass[]> {
        return await this.GetAllRecords()
    }

    public async getById(Id: number): Promise<FirmaConservadorClass> {
        let records = await this.GetRecordsByIndex(0, 1, 'Id', Id, Id)
        if (records.length) {
            return records[0]
        }
        return null
    }

    public async getByLocalId(Id: number): Promise<FirmaConservadorClass> {
        let records = await this.GetRecordsById(0, 1, Id, Id)
        if (records.length) {
            return records[0]
        }
        return null
    }

    public async getByOrdenLocalId(OrdenLocalId: number): Promise<FirmaConservadorClass> {
        let records = await this.GetRecordsByIndex(0, 1, 'OrdenLocalId', OrdenLocalId, OrdenLocalId)
        if (records.length) {
            return records[0]
        }
        return null
    }

    public async update(record: FirmaConservadorClass): Promise<number> {
        return await this.UpdateRecord(record)
    }

    public async delete(record: FirmaConservadorClass): Promise<void> {
        if (!record?.LocalId) return
        await this.DeleteRecord(record.LocalId)
    }

}